module.exports = __webpack_public_path__ + "fontawesome-webfont-.45c73723862c6fc5eb3d.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/font-awesome/fontawesome-webfont-.eot
// module id = 374
// module chunks = 2